import React, { RefObject, useState } from 'react'
import { useElementMetrics } from '../../hooks/useElementMetrics'
import { animated, useSpring } from 'react-spring'

export const ReservationStepHeader = ({
  id,
  stepText,
  children,
}: {
  id: string
  stepText?: string
  children: React.ReactNode
}) => (
  <div
    className="bg-primary text-white font-europa-yu mx-auto text-center desktop:w-full desktop:p-[20px_32px_24px] tablet:w-full tablet:p-[20px_32px_24px] sp:p-3"
    id={id}
  >
    {stepText && (
      <div className="font-europa-yu inline-block mx-auto text-center bg-white text-primary text-[17px] font-bold tablet:px-4 desktop:px-4 sp:px-3">
        {stepText}
      </div>
    )}
    <div className="text-center text-white text-[15px] font-bold tablet:mt-2 desktop:mt-2 sp:mt-2">
      {children}
    </div>
  </div>
)

export const ReservationStepBody = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [ref, setRef] = useState<HTMLElement | RefObject<HTMLElement> | null>(
    null
  )
  const metrics = useElementMetrics(ref)
  const styleProps = useSpring({
    maxHeight: metrics ? metrics.offsetHeight + 48 : 0,
  })
  return (
    <animated.div
      className="overflow-hidden desktop:w-[1000px] desktop:mx-auto"
      style={styleProps}
    >
      <div className="text-text-black sp:text-left" ref={setRef}>
        {children}
      </div>
    </animated.div>
  )
}

export const ReservationStepSubHeader = ({
  children,
}: {
  children: React.ReactNode
}) => (
  <div className="font-europa-yu font-bold tracking-[0.07rem] tablet:text-center desktop:text-center tablet:mt-0 desktop:mt-0 tablet:mb-8 desktop:mb-8 sp:text-left sp:m-[32px_24px_24px]">
    {children}
  </div>
)
